<template>
	<v-flex xs12>
		<v-card>
			<v-card-title>
				<v-flex xs3>
					<v-toolbar-title>Content</v-toolbar-title>
				</v-flex>
				<v-flex xs6>
					<v-text-field
						v-model="search"
						append-icon="search"
						label="Search"
						single-line
						hide-details
					></v-text-field>
				</v-flex>
				<v-flex class="text-right" xs3>
					<v-btn to="/content/add" dark color="indigo">
						<v-icon dark>add_circle</v-icon>New
					</v-btn>
				</v-flex>
			</v-card-title>
			<v-data-table
				:headers="headers"
				:items="body"
				:search="search"
				:options.sync="options"
				:server-items-length="total"
				:loading="loading"
				:sort-by="['title']"
				:sort-desc="[false]"
			>
				<template v-slot:item.title="{ item }">
					<a :href="'/content/edit/' + item.id">{{ item.title }}</a>
				</template>
				<template v-slot:item.category="{ item }">
					<a :href="'/category/edit/' + item.categoryId">{{ item.category }}</a>
				</template>
				<template v-slot:item.action="{ item }">
					<v-icon
						small
						class="mr-2"
						@click="fixedDeparture(item)"
						title="Fixed Departure"
						>gps_fixed</v-icon
					>
					<v-icon small class="mr-2" @click="image(item)" title="Image"
						>image</v-icon
					>
					<v-icon
						small
						class="mr-2"
						@click="attachment(item)"
						title="Attachment"
						>picture_as_pdf</v-icon
					>
					<!-- <v-icon small class="mr-2" @click="editItem(item)" title="Edit">edit</v-icon> -->
					<v-icon small @click="deleteItem(item)" title="Delete">delete</v-icon>
				</template>
				<template v-slot:no-data>
					<v-alert :value="true">No results found.</v-alert>
				</template>
			</v-data-table>
		</v-card>
	</v-flex>
</template>

<script>
	import commonservice from "../../shared/common.service";
	export default {
		data() {
			return {
				search: "",
				loading: false,
				options: {},
				total: 0,
				headers: [
					{ text: "Title", value: "title" },
					{ text: "Category", value: "category" },
					{ text: "Actions", value: "action", sortable: false },
				],
				body: [],
			};
		},
		watch: {
			options: {
				handler() {
					this.getData();
				},
				deep: true,
			},
		},
		methods: {
			fixedDeparture(item) {
				this.$store.commit("fixedDeparture/SET_FIXED_DEPARTURE_DATA", {
					key: "contentId",
					value: item.id,
				});
				this.$router.push("/fixedDeparture/");
			},
			editItem(item) {
				this.$router.push("/content/edit/" + item.id);
			},
			image(item) {
				this.$store.commit("contentImage/SET_CONTENT_IMAGE_DATA", {
					key: "contentId",
					value: item.id,
				});
				this.$router.push("/contentImage/");
			},
			attachment(item) {
				this.$store.commit("contentAttachment/SET_CONTENT_ATTACHMENT_DATA", {
					key: "contentId",
					value: item.id,
				});
				this.$router.push("/contentAttachment/");
			},
			deleteItem(item) {
				commonservice
					.showDialog("Delete", "Are you sure, you want to delete content?")
					.then((result) => {
						if (result.value) {
							this.$store
								.dispatch("content/deleteContent", { id: item.id })
								.then(() => {
									this.getData();
									commonservice.showSuccessMessage(
										"Content deleted successfully"
									);
								});
						}
					});
			},
			getData() {
				this.$store
					.dispatch("content/loadContent", {
						pagination: this.options,
						search: this.search,
					})
					.then((response) => {
						this.loading = false;
						this.body = response.data.data;
						this.total = response.data.total;
					})
					.catch(() => {
						this.loading = false;
					});
			},
		},
	};
</script>
